import { Card, Col, Row } from "antd";
import React from "react";
import styled from "styled-components";

import { BunnyLogo } from "../../../components/logos";

const LoginContainer = styled(Row)`
  height: 100% !important;
  background-image: url(/facilityImage.jpg);
  background-size: cover;

  .ant-card {
    width: 80%;
    border-radius: 5px;
    form {
      text-align: center;
    }
  }
`;

const LoginLayout = ({ children }) => (
  <LoginContainer justify="center" align="middle">
    <Col xs={{ span: 24 }} md={{ span: 16 }} lg={{ span: 12 }} align="center">
      <Card>
        <BunnyLogo height={100} width={300} margin={"0px 0px 24px 0px"} />
        <Row justify="center">
          <Col
            xs={{ span: 24 }}
            sm={{ span: 20 }}
            lg={{ span: 14 }}
            align="center"
          >
            {children}
          </Col>
        </Row>
      </Card>
    </Col>
  </LoginContainer>
);

export { LoginLayout };
